export enum PES_FLAGS {
  Substitutions = 'outsourcedSubstitutions',
  UnifiedCheckout = 'unifiedCheckout',
}
